export default __webpack_public_path__ + "static/Frames-ebf3566bf167dbc8245c22e50fdff950.png";